import { render, staticRenderFns } from "./ordersDetails.vue?vue&type=template&id=2b47a788&scoped=true&"
import script from "./ordersDetails.vue?vue&type=script&lang=js&"
export * from "./ordersDetails.vue?vue&type=script&lang=js&"
import style0 from "./ordersDetails.vue?vue&type=style&index=0&id=2b47a788&prod&scoped=true&lang=less&"
import style1 from "./ordersDetails.vue?vue&type=style&index=1&id=2b47a788&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47a788",
  null
  
)

export default component.exports